import React from "react";

/**
 * Frame iOS simplificado (bezel, dynamic island, status bar e home indicator),
 * derivado do starter "ios-frame.jsx" do Claude Design. Só a variante escura,
 * que é a usada no design.
 */
const StatusIcons = ({ color }) => (
  <>
    <svg width="19" height="12" viewBox="0 0 19 12" aria-hidden="true">
      <rect x="0" y="7.5" width="3.2" height="4.5" rx="0.7" fill={color} />
      <rect x="4.8" y="5" width="3.2" height="7" rx="0.7" fill={color} />
      <rect x="9.6" y="2.5" width="3.2" height="9.5" rx="0.7" fill={color} />
      <rect x="14.4" y="0" width="3.2" height="12" rx="0.7" fill={color} />
    </svg>
    <svg width="17" height="12" viewBox="0 0 17 12" aria-hidden="true">
      <path
        d="M8.5 3.2C10.8 3.2 12.9 4.1 14.4 5.6L15.5 4.5C13.7 2.7 11.2 1.5 8.5 1.5C5.8 1.5 3.3 2.7 1.5 4.5L2.6 5.6C4.1 4.1 6.2 3.2 8.5 3.2Z"
        fill={color}
      />
      <path
        d="M8.5 6.8C9.9 6.8 11.1 7.3 12 8.2L13.1 7.1C11.8 5.9 10.2 5.1 8.5 5.1C6.8 5.1 5.2 5.9 3.9 7.1L5 8.2C5.9 7.3 7.1 6.8 8.5 6.8Z"
        fill={color}
      />
      <circle cx="8.5" cy="10.5" r="1.5" fill={color} />
    </svg>
    <svg width="27" height="13" viewBox="0 0 27 13" aria-hidden="true">
      <rect x="0.5" y="0.5" width="23" height="12" rx="3.5" stroke={color} strokeOpacity="0.35" fill="none" />
      <rect x="2" y="2" width="20" height="9" rx="2" fill={color} />
      <path d="M25 4.5V8.5C25.8 8.2 26.5 7.2 26.5 6.5C26.5 5.8 25.8 4.8 25 4.5Z" fill={color} fillOpacity="0.4" />
    </svg>
  </>
);

export function IosDevice({ children, width = 402, height = 874, time = "9:41" }) {
  return (
    <div className="pp-ios" style={{ width, height }} aria-hidden="true">
      <div className="pp-ios-island" />
      <div className="pp-ios-status">
        <span className="pp-ios-time">{time}</span>
        <span className="pp-ios-icons">
          <StatusIcons color="#fff" />
        </span>
      </div>
      <div className="pp-ios-screen">{children}</div>
      <div className="pp-ios-home">
        <span />
      </div>
    </div>
  );
}
